//export const dispatchCategoryId = 1;
//export const driverCategoryId = 8;
//export const equipmentCategoryId = 35;
//export const shiftCategoryId = 51;
//export const hrCategoryId = 41;

export const fleetDepartmentOptions = [
	{
		isGroup: true,
		display: 'In House',
	},
	{
		display: 'Billing Department',
		value: 'billing',
	},
	{
		display: 'Safety Department',
		value: 'safety',
	},
	{
		display: 'General Office / Dispatch / Fleet',
		value: 'dispatch',
	},
	{
		isGroup: 'Driver',
		display: 'Superior Drivers & Mechanics',
	},
	{
		display: 'Colton (COL)',
		value: 'colton',
	},
	{
		display: 'Paramount (LA) / Montebello (MB) / Huntington Beach (HB)',
		value: 'paramount',
	},
	{
		display: 'Portland (PDX)',
		value: 'portland',
	},
	{
		display: 'Eugene (EUG)',
		value: 'eugene',
	},
	{
		display: 'Phoenix (PHX)',
		value: 'phoenix',
	},
	{
		display: 'Tacoma (TAC / KENT / SEA)',
		value: 'tacoma',
	},
	{
		display: 'Ferndale (FERN)',
		value: 'ferndale',
	},
	{
		display: 'San Diego (SD)',
		value: 'sandiego',
	},
	{
		display: 'Long Beach (LB)',
		value: 'longbeach',
	},
	{
		isGroup: 'Williams',
		display: 'Williams Drivers & Mechanics',
	},
	{
		display: 'Williams Stockton (STK)',
		value: 'stockton',
	},
	{
		display: 'Williams San Jose (SJ)',
		value: 'sanjose',
	},
	{
		display: 'Williams Colton (WCOL)',
		value: 'wcolton',
	},
	{
		display: 'Williams Sacramento (SAC)',
		value: 'sacramento',
	},
	{
		display: 'Williams Chico (CHI)',
		value: 'chico',
	},
	{
		display: 'Williams Western Tank Shop (WTS)',
		value: 'westerntankshop',
	},
	{
		display: 'Williams Las Vegas (LV)',
		value: 'lasvegas',
	},
	{
		display: 'Williams Martinez (MAR)',
		value: 'martinez',
	},
	{
		display: 'Williams Paso Robles (PR)',
		value: 'pasorobles',
	},
	{
		display: 'Williams Bakersfield (BAK)',
		value: 'bakersfield',
	},
	{
		display: 'Williams Fresno (FRE)',
		value: 'fresno',
	},
	{
		display: 'Williams Long Beach (WLB)',
		value: 'wlongbeach',
	},
	{
		display: 'Williams Sparks (SPK)',
		value: 'sparks',
	},
	{
		display: 'Williams Salinas (SAL)',
		value: 'salinas',
	},
	{
		display: 'Williams Banta Chevron (BAN)',
		value: 'bantachevron',
	},
	{
		display: 'Williams Gilroy (GIL)',
		value: 'gilroy',
	},
];
